/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native';

const GAP = 12;
const SIDE_PADDING = 16;
const MOBILE_BOTTOM_SPACING = 24;
const DESKTOP_BOTTOM_SPACING = 24;
const MOBILE_VERTICAL_GAP = GAP;

const styles = StyleSheet.create({
  columnWrapper: {
    gap: GAP,
    paddingHorizontal: SIDE_PADDING,
    justifyContent: 'flex-start',
  },
  itemContainer: {
    flex: 1,
    marginBottom: GAP,
  },

  mobileGrid: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingHorizontal: SIDE_PADDING,
    gap: GAP,
    marginLeft: -4,
  },
  mobileColumn: {
    flex: 1,
  },
  mobileItem: {
    marginBottom: MOBILE_VERTICAL_GAP,
  },

  contentContainerMobile: {
    paddingBottom: MOBILE_BOTTOM_SPACING,
  },
  contentContainerDesktop: {
    paddingBottom: DESKTOP_BOTTOM_SPACING,
  },
});

export default styles;
